import React from "react"

const index = () => {
  return (
    <div className="flex border rounded-lg border-white/[0.12] h-screen items-center justify-center ">
      <p className="max-w-[500px] mx-auto mb-9 font-medium md:text-lg">
        Couldn't get bets, reload the page.
      </p>
    </div>
  )
}

export default index
